<template>
    <div class="expert_schedule">
        <div class="expertInfo">
            <img v-if="expertInfo.photo" :src="expertInfo.photo" alt="" onerror="common.imgError(1,event)">
            <img v-else src="@/assets/images/defaultHead.png" alt="" >
            <div class="info_con flex">
                <div class="info">
                    <span>{{expertInfo.name}}</span>
                    <!-- <p>{{expertInfo.title}}</p> -->
                    <p>{{expertInfo.company}}</p>
                </div>
                <!-- <router-link class="home_icon flex" :to="{path:'/expert/details',query:{id:writer_id}}">
                    <van-icon name="wap-home-o" />
                    <p>点击进入专家主页</p>
                </router-link> -->
            </div>
        </div>
        <div class="scheduleCon">
            <van-tabs  type="card" 
            @change="changeParentTabs"
            title-active-color="#fff"
            title-inactive-color="#222"
            color="#ccc"
            textAlign="center"
            background="#f8f8f8" >
                <van-tab :title="key" v-for="(item,key,index) in dateTime" :key="index" >
                    <div class="channellist flex">
                        <div class="channelblock line-clamp-1"  v-for="(value,childkey,childindex) in tableData" :key="childindex" @click="changeChildTabs(childkey)">
                            <span :class="item==childkey?'active':''">{{childkey}}</span>
                        </div>
                    </div>
                    <table
                    border="1px solid #efefef"
                    >
                        <tr >
                            <th>时间</th>
                            <th>会场</th>
                            <th>session</th>
                            <th>任务</th>
                            <th>讲题</th>
                        </tr>
                        <tbody>
                            <tr v-for="(val) in tableData[item]" :key="val.cdw_id">
                                <td v-if="!val.detail_name">{{(val.chapter_start_at.split(' ')[1]).slice(0,5)+' - '+(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</td>
                                <td v-if="val.detail_name">{{(val.detail_start_at.split(' ')[1]).slice(0,5)+' - '+(val.detail_end_at.split(' ')[1]).slice(0,5)}}</td>
                                <td>{{val.session_name}}</td>
                                <td>{{val.chapter_name}}</td>
                                <td>{{val.title}}</td>
                                <td>{{val.detail_name}}</td>
                            </tr>
                        </tbody>
                    </table>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>
<script>
	import {ExpertInformation,ExpertSchedule} from '../../config/interface.js'
    export default{
        data(){
            return{
                active:1,
                writer_id:0,
                meeting_id:0,
                dateTime:{
                },
                parent_id:'',
                scheduleData:{},
                tableData:{},
                expertInfo:{},
            }
        },
        mounted(){
            this.meeting_id=this.$route.query.meeting_id;
            this.writer_id=this.$route.query.writer_id;
            this.getExpertInfo();
            this.querySchedule();
            
        },
        methods:{
            //专家信息
			getExpertInfo(id){
				const url=ExpertInformation;
				const method='POST';
				let params={
					writer_id:this.writer_id,
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.expertInfo={
							photo:data.photo,
							name:data.name,
							company:data.company,
                            title:data.title['name'],
							positionName:data.title.name,
							des:data.des
						}
					}
				})
			},
            //日程
            querySchedule(){
                const url=ExpertSchedule;
				const method='POST';
				let params={
					writer_id:this.writer_id,
                    meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
                        //  let allArr=[];
                        // for(let i in data){                           
                        //     let childArr=[];
                        //     for(let j in data[i]){
                        //         data[i]['全部']=childArr.concat(data[i][j]);
                        //         childArr=childArr.concat(data[i][j]);
                        //         data['全部']=allArr.concat(data[i][j]);
                        //         allArr=allArr.concat(data[i][j]);
                        //     }
                        // }
                        this.scheduleData=data;
                        console.log(this.scheduleData);
                        let dateArr= Object.keys(data);
                        console.log(dateArr);
                        this.tableData=data[dateArr[0]];
                        this.parent_id=dateArr[0];
                        dateArr.forEach((item,index)=>{;
                            this.$set(this.dateTime,item,Object.keys(data[item])[0]);
                        })
                        // console.log(this.tableData);
					}
				})
            },
            changeParentTabs(index,val){
                this.tableData=this.scheduleData[val];
                // console.log(this.tableData);
                this.parent_id=val;

            },
            changeChildTabs(value){
                this.dateTime[this.parent_id]=value;
            }
        }
    }
</script>
<style scoped lang="scss">
    .expert_schedule{
        width:100%;
        height: 100%;
        background:#f4f4f4;
        .expertInfo{
            padding:10px 20px;
            display: flex;
            background:#fff;
            img{
                width:100px;
                height: 100%;
            }
            .home_icon{
                align-items: center;
                font-size: 13px;
                color:#548cff;
                i{
                    font-size:16px;
                    margin-right:3px;
                }
            }
            .info_con{
                flex:1;
                padding: 5px 10px;
                flex-direction: column;
                justify-content: space-between;
                .info{
                    span{
                        font-size:14px;
                        font-weight: bold;

                    }
                    p{
                        color:#666;
                    }
                }
            }
        }
        .scheduleCon{
            padding-top:15px;
        }
        .channellist{
            padding:10px;
            .channelblock{
                margin:0 5px;
                >span{
                    display: block;
                    width:70px;
                    height: 30px;
                    line-height: 30px;
                    padding:0 5px;
                    border-radius: 5px;
                    background:#fff;
                    color:#888;
                    font-size:13px;
                    text-align: center;
                }
                span.active{
                    color:#fff;
                    background:#548cff;
                }
            }
        }
        table{
            width: 100%;
            border-collapse: collapse;
            text-align: center;
            border:1px solid #999;
            th{
                background: #e9f0ff;
                color:#5f8cff;
                height: 35px;
                border:0px;
                font-size:14px;
            }
            td{
                padding:4px 2px;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/Expert/Schedule.vue